goog.provide("shadow.js.shim.module$$tiptap$extension_document");
goog.provide("module$shadow_js_shim_module$$tiptap$extension_document");
shadow.js.shim.module$$tiptap$extension_document = shadow.js.nativeProvides["@tiptap/extension-document"] = shadow$bridge("@tiptap/extension-document");
module$shadow_js_shim_module$$tiptap$extension_document.default = shadow.js.shim.module$$tiptap$extension_document;
